<dxc-button 
  [mode]="mode"
  label="{{label}}"
  (onClick)="onButtonClick()"
  [disabled]="disabled"
  [size]="size"
  [margin]="margin"
  iconSrc="{{iconSrc}}"
  [iconPosition]="iconPosition"
  [class]="applyclass"
>
</dxc-button>